import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from 'libraries/Dialog';

const AddSkillDialog = ({
    open, onClose, onAdd, loading, skill
}) => (
    <Dialog
        open={open}
        maxWidth="sm"
        onClose={onClose}
        titleComponent="Add skill to question"
        handleClose={onClose}
        actionComponent={(
            <>
                <Button
                    className="u-txt--bold u-pdn--lx5 u-pdn--rx5"
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={onAdd}
                    disabled={loading}
                    style={{ width: 150 }}
                    className="u-pdn--lx6 u-pdn--rx6"
                >
                    {
                        loading ? (
                            <CircularProgress
                                size={24}
                                thickness={3}
                            />
                        ) : <span>Add Skill</span>
                    }
                </Button>
            </>
        )}
    >
        Do you want to add <b>{skill}</b> skill to this question?
    </Dialog>
);

export default AddSkillDialog;
